import { type FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetLotterySeasonsHistoryListQuery } from '@/api/queries/lottery/lottery';
import { ChoseHistorySeason } from '@/components/Lottery/ChoseHistorySeason/ChoseHistorySeason';
import { useCurrentLotteryTier } from '@/components/Lottery/hooks';
import { LotteryBgWrapper } from '@/components/Lottery/LotteryBgWrapper/LotteryBgWrapper';
import { LotterySeasonHistoryList } from '@/components/Lottery/LotterySeasonsHistoryList/LotterySeasonsHistoryList';
import { SeasonWinnersHistory } from '@/components/Lottery/SeasonWinnersHistory/SeasonWinnersHistory';
import { SplitTitle } from '@/components/ui/SplitTitle/SplitTitle';

import css from './styles.module.scss';

const LotteryHistory: FC = () => {
  const { t } = useTranslation();
  const type = useCurrentLotteryTier();
  const { data } = useGetLotterySeasonsHistoryListQuery({ type });
  const [seasonId, setSeasonId] = useState<string | null>(null);

  const [seasonListIsOpen, setSeasonListIsOpen] = useState(false);

  useEffect(() => {
    if (data && data[0]) {
      setSeasonId(data[0].id);
    }
  }, [data]);

  const seasonData = data?.find(({ id }) => id === seasonId);

  const changeSeason = (newSeasonId: string): void => {
    setSeasonId(newSeasonId);
    setSeasonListIsOpen(false);
  };

  return (
    <LotteryBgWrapper type={type}>
      <div className={css.lotteryHistory}>
        <SplitTitle className="mb-6" text={t('History & Winners')} />
        {seasonData && (
          <>
            <ChoseHistorySeason
              {...seasonData}
              seasonListIsOpen={seasonListIsOpen}
              handleClick={() => setSeasonListIsOpen((state) => !state)}
            />
            {data && seasonId && (
              <>
                {seasonListIsOpen ? (
                  <LotterySeasonHistoryList
                    data={data}
                    activeId={seasonId}
                    changeSeason={changeSeason}
                  />
                ) : (
                  <SeasonWinnersHistory seasonId={seasonId} type={type} />
                )}
              </>
            )}
          </>
        )}
      </div>
    </LotteryBgWrapper>
  );
};

export { LotteryHistory };
